<app-color-indicator
  [colors]="value"
  (clicked)="toggleSelection($event)"
  [size]="size"
  [hideChosenValue]="hideChosenValue"
></app-color-indicator>
